document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.slider').forEach(slider => {
    const slides = slider.querySelector('.slides');
    const images = slider.querySelectorAll('img');
    let index = 0;
    let startX = 0;
    let endX = 0;

    const next = slider.querySelector('.next');
    const prev = slider.querySelector('.prev');

    next.onclick = () => move(1);
    prev.onclick = () => move(-1);

    function move(step) {
      index = (index + step + images.length) % images.length;
      slides.style.transform = `translateX(-${index * 100}%)`;
    }

    slides.addEventListener('touchstart', e => startX = e.touches[0].clientX);
    slides.addEventListener('touchmove', e => endX = e.touches[0].clientX);
    slides.addEventListener('touchend', () => {
      if (startX - endX > 50) move(1);
      if (endX - startX > 50) move(-1);
    });
  });
});
